<div
  *ngIf="isOpen"
  class="data-modal-backdrop"
  role="presentation"
  (click)="onBackdropClick($event)"
>
  <div
    [attr.class]="panelClass ? 'data-modal ' + panelClass : 'data-modal'"
    [attr.id]="dialogId || null"
    [style.--txm-max-width]="width"
    role="dialog"
    [attr.aria-modal]="true"
    [attr.aria-label]="dialogAriaLabel"
    (click)="onDialogClick($event)"
  >
    <ng-container *ngIf="customHeader; else defaultHead">
      <ng-content select="[modal-header]"></ng-content>
    </ng-container>
    <ng-template #defaultHead>
      <div class="data-modal__head">
        <div class="data-modal__head-text">
          <h4 class="data-modal__title">{{ title }}</h4>
          <div class="data-modal__subtitle-wrap">
            <ng-content select="[modal-subtitle]"></ng-content>
          </div>
        </div>
        <button
          *ngIf="showCloseButton"
          type="button"
          class="data-modal__x"
          (click)="close()"
          aria-label="Close"
        >
          ×
        </button>
      </div>
    </ng-template>

    <div [ngClass]="['data-modal__body', bodyClass]">
      <ng-content></ng-content>
    </div>

    <ng-content select="[modal-footer]"></ng-content>
  </div>
</div>
